import styled from 'styled-components';
import { body2, colors } from 'ui/theme';

export const NoOptionSubMenu = styled.div`
  ${body2}
  color: ${colors.grey25};
  display: flex;
  justify-content: center;
  overflow-wrap: anywhere;
  white-space: nowrap;
  width: 100%;
`;
